/**
 * Streaming Limits Overlay Component
 * Shows remaining streaming time for free tier users
 */

import React from 'react';
import { LINE_GRADIENT } from '../../constants/gradients';

interface StreamingLimitsOverlayProps {
  remainingTime: number;  // seconds
  isVisible: boolean;
  onUpgradePress: () => void;
}

const StreamingLimitsOverlay: React.FC<StreamingLimitsOverlayProps> = ({
  remainingTime,
  isVisible,
  onUpgradePress
}) => {
  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    
    if (hours > 0) {
      return `${hours}h ${mins}m left`;
    } else {
      return `${mins}m left`;
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={onUpgradePress}
      className="fixed bottom-16 right-4 bg-black/70 backdrop-blur-sm rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 active:scale-95 z-50"
      style={{
        animation: 'fadeIn 0.5s ease-out'
      }}
    >
      <div className="flex items-center gap-2 px-3 py-2">
        {/* Timer Display */}
        <span className="text-white text-xs font-bold">
          {formatTime(remainingTime)}
        </span>

        {/* Upgrade Button */}
        <span 
          className="text-xs font-bold"
          style={{
            backgroundImage: LINE_GRADIENT,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Upgrade
        </span>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </button>
  );
};

export default StreamingLimitsOverlay;
